import React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { LayoutPageGrid } from '../../../../ui/LayoutGrid';
import { Loading } from '../../../../ui/Loading';
import { useSeasonByIdQuery } from '../../../../schema';
import { EditSeasonForm } from './EditSeasonForm';

export const EditSeasonPage = () => {
  const { seasonId } = useParams<{ seasonId: string }>();
  const { data, loading, error } = useSeasonByIdQuery({
    variables: { id: seasonId },
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    toast.error('Ошибка загрузки сезона');
    return null;
  }

  return (
    <LayoutPageGrid title="Редактирование сезона">
      <EditSeasonForm seasonId={seasonId} data={data} />
    </LayoutPageGrid>
  );
};
